export const manifest = {
  screens: {
    scr_4hiihr: { name: "A Small Idea for ESTEVE", route: "/", state: {"slide":0}, position: {"x":39360,"y":220} },
  },
  sections: {
    sec_cmsdzd: { name: "Business Proposal Flow", x: 0, y: 0, width: 57520, height: 1180 },
    sec_zf5ksd: { name: "Implementation & Execution", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_f1atcp: { name: "Interactive Demo", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_cmsdzd", children: [
      { kind: "screen", id: "scr_aqx7nl" },
      { kind: "screen", id: "scr_b2ks1n" },
      { kind: "screen", id: "scr_4hiihr" },
      { kind: "screen", id: "scr_7yzgqg" },
      { kind: "screen", id: "scr_5efz5w" },
      { kind: "screen", id: "scr_fl630q" },
      { kind: "screen", id: "scr_qclpfx" },
      { kind: "screen", id: "scr_srlp84" },
      { kind: "screen", id: "scr_pui1o4" },
      { kind: "screen", id: "scr_pgbs2t" },
    ] },
    { kind: "section", id: "sec_zf5ksd", children: [
      { kind: "screen", id: "scr_6h2q2t" },
      { kind: "screen", id: "scr_8xb5u0" },
      { kind: "screen", id: "scr_1qfnhg" },
    ] },
    { kind: "section", id: "sec_f1atcp", children: [
      { kind: "screen", id: "scr_an1eku" },
    ] },
  ],
}
